export default __webpack_public_path__ + "static/media/token-s.a34df7d1.svg";